export const status = {
  ALL: 'ALL',
  WAITING: 'WAITING',
  INPROGRESS: 'INPROGRESS',
  CANCEL: 'CANCEL',
  COMPLETED: 'COMPLETED',
  WATCHING: 'WATCHING',
  NOTIFY: 'PENDING',
}

export const statusText = {
  ALL: 'ทั้งหมด',
  WAITING: 'รอการดำเนินการ',
  INPROGRESS: 'กำลังดำเนินการ',
  CANCEL: 'ยกเลิก',
  COMPLETED: 'สำเร็จ',
  WATCHING: 'เฝ้าติดตาม',
  NOTIFY: 'แจ้งซ่อม',
}

export const servicesStatus = {
  ALL: 'ALL',
  WAITING: 'WAITING',
  ASSIGNED: 'ASSIGNED',
  CANCEL: 'CANCEL',
  STARTED: 'STARTED',
  DONE: 'DONE',
  NOTIFY: 'PENDING',
}

export const servicesStatusText = {
  ALL: 'ทั้งหมด',
  WAITING: 'รอการดำเนินการ',
  ASSIGNED: 'จ่ายงานซ่อมแล้ว',
  CANCEL: 'ยกเลิก',
  DONE: 'สำเร็จ',
  STARTED: 'เริ่มงานซ่อมแล้ว',
  NOTIFY: 'แจ้งซ่อม',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const repairJobType = {
  TIRES_WHEELS: { value: 'TIRES_WHEELS', label: 'ยาง, กระทะ, น๊อตล้อ' },
  PERIODIC_MAINTENANCE: { value: 'PERIODIC_MAINTENANCE', label: 'เช็คระยะตามกําหนด (ถ่ายนํ้ามันเครื่องอัดจารบี)' },
  SUSPENSION: { value: 'SUSPENSION', label: 'ช่วงล่าง' },
  ENGINE: { value: 'ENGINE', label: 'เครื่องยนต์' },
  TRANSMISSION: { value: 'TRANSMISSION', label: 'เกียร์ เฟืองท้าย เพลา' },
  AIR_SYSTEM: { value: 'AIR_SYSTEM', label: 'ระบบลม' },
  ELECTRICAL_SYSTEM: { value: 'ELECTRICAL_SYSTEM', label: 'ระบบไฟฟ้า' },
  WELDING_REPAIR: { value: 'WELDING_REPAIR', label: 'เชื่อม ปะ ผุ ซ่อมแชสซี' },
  CABIN: { value: 'CABIN', label: 'หัวเก๋ง' },
  PAINTING: { value: 'PAINTING', label: 'ทำสี' },
  OTHER: { value: 'OTHER', label: 'อื่น ๆ' },
}
